import { apiCall } from "../api/api";

export const adminLogin = async (username: string, password: string) => {
  const response = await apiCall.post("adminlogin", { username, password });
  return response.data;
};
